import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Icon, Header } from 'semantic-ui-react';
import styled from 'styled-components';

import { Planning } from 'actions';
import { colors } from 'utils/colors';
import { translation as translationPlanning } from '../../Translation/planning';

class EducationCard extends Component {
  state = {
    expanded: false,
  };

  componentDidMount() {
    const { dispatch, savingGoals } = this.props;

    if (Object.keys(savingGoals).length === 0) {
      dispatch(Planning.getSavingGoals());
    }
  }

  toggleExpand = () => {
    this.setState((prev) => ({ expanded: !prev.expanded }));
  };

  render() {
    const { expanded } = this.state;
    const { savingGoals, french } = this.props;
    let { tuition, accommodation } = savingGoals.undergraduate || {};
    tuition = Math.round(tuition || 29190);
    accommodation = Math.round(accommodation || 51484);
    const total = tuition + accommodation;
    const language = french ? 'fr' : 'en';

    return (
      <CardWrapper expanded={expanded} french={french}>
        <div style={{ minWidth: '341px', padding: '20px' }}>
          <IconHeader>
            <Icon
              name="graduation cap"
              color="orange"
              size="large"
              style={{ margin: 0 }}
            />
          </IconHeader>

          <CardTitle>
            {translationPlanning[language].TARGET_SAVING.EDUCATION.TITLE}
          </CardTitle>
          <CardSubtitle>
            {translationPlanning[language].TARGET_SAVING.EDUCATION.SUBTITLE}
          </CardSubtitle>

          <ShowToggle onClick={this.toggleExpand}>
            {expanded ? (
              <React.Fragment>
                {translationPlanning[language].TARGET_SAVING.SHOW_LESS}{' '}
                <Icon name="angle up" />
              </React.Fragment>
            ) : (
              <React.Fragment>
                {translationPlanning[language].TARGET_SAVING.LEARN_MORE}{' '}
                <Icon name="angle down" />
              </React.Fragment>
            )}
          </ShowToggle>
        </div>
        <CollapsibleSection expanded={expanded}>
          <div>
            <Divider />
            <SectionTitle style={{ textAlign: 'center' }}>
              {
                translationPlanning[language].TARGET_SAVING.EDUCATION
                  .TABLE_TITLE
              }
            </SectionTitle>
            <SubText style={{ textAlign: 'center' }}>
              {
                translationPlanning[language].TARGET_SAVING.EDUCATION
                  .TABLE_SUBTITLE
              }
            </SubText>

            <Row>
              <span>
                {translationPlanning[language].TARGET_SAVING.EDUCATION.TUITION}
              </span>
              <Value>${tuition.toLocaleString()}</Value>
            </Row>
            <Row>
              <span>
                {
                  translationPlanning[language].TARGET_SAVING.EDUCATION
                    .ROOM_AND_BOARD
                }
              </span>
              <Value>${accommodation.toLocaleString()}</Value>
            </Row>

            <TotalRow>
              <span>
                {translationPlanning[language].TARGET_SAVING.EDUCATION.TOTAL}
              </span>
              <TotalValue>${total.toLocaleString()}</TotalValue>
            </TotalRow>

            <Divider />

            <SectionLabel>
              {
                translationPlanning[language].TARGET_SAVING.EDUCATION
                  .CONTRIBUTION_TITLE
              }
            </SectionLabel>
            <SubText>
              {
                translationPlanning[language].TARGET_SAVING.EDUCATION
                  .CONTRIBUTION_SUBTITLE
              }
            </SubText>

            <SectionLabel style={{ whiteSpace: 'noWrap' }}>
              {
                translationPlanning[language].TARGET_SAVING.EDUCATION
                  .GRANT_TITLE
              }
            </SectionLabel>
            <SubText>
              {translationPlanning[language].TARGET_SAVING.EDUCATION.GRANT_TEXT}{' '}
              <a
                href="https://www.canada.ca/en/revenue-agency/services/tax/individuals/topics/registered-education-savings-plans-resps/canada-education-savings-programs-cesp/canada-education-savings-grant-cesg.html"
                target="_blank"
                rel="noopener noreferrer"
              >
                {translationPlanning[language].TARGET_SAVING.EDUCATION.HERE}
              </a>
              .
            </SubText>
            <SectionLabel style={{ whiteSpace: 'nowrap' }}>
              {translationPlanning[language].TARGET_SAVING.EDUCATION.QESI_TITLE}
            </SectionLabel>
            <SubText>
              {translationPlanning[language].TARGET_SAVING.EDUCATION.QESI_TEXT}
            </SubText>
          </div>
        </CollapsibleSection>
      </CardWrapper>
    );
  }
}

EducationCard.propTypes = {
  dispatch: PropTypes.func.isRequired,
  savingGoals: PropTypes.object,
  french: PropTypes.bool,
};

EducationCard.defaultProps = {
  savingGoals: {},
  french: false,
};

export default connect((state) => ({
  savingGoals: state.Planning.savingGoals,
  french: state.Storage.language === 'fr',
}))(EducationCard);

const CardWrapper = styled.div`
  background: white;
  border-radius: 1rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  text-align: center;
  width: 100%;
  max-width: 473px;
  margin: 0.5rem;
  overflow: hidden;
  max-height: ${(props) =>
    props.expanded ? (props.french ? '700px' : '665px') : '214px'};
  transition: max-height 0.4s ease-in-out;
`;

const IconHeader = styled.div`
  background: #ffe7d6;
  border-radius: 50%;
  display: inline-block;
  padding: 0.75rem;
  margin-bottom: 1rem;
`;

const CardTitle = styled.h3`
  font-size: 1.2rem;
  font-weight: 700;
  margin-bottom: 0.25rem;
`;

const CardSubtitle = styled.p`
  color: #555;
  margin-bottom: 1rem;
`;

const ShowToggle = styled.button`
  background: none;
  border: none;
  color: ${colors.blue};
  font-weight: 600;
  cursor: pointer;
  margin-bottom: 0.5rem;

  &:hover {
    text-decoration: underline;
  }
  i {
    text-decoration: none !important;
  }
`;

const CollapsibleSection = styled.div`
  overflow: hidden;
  text-align: left;
  max-height: ${(props) => (props.expanded ? '700px' : '0')};
  padding: ${(props) => (props.expanded ? '0 20px 20px' : '0 20px')};
  opacity: ${(props) => (props.expanded ? 1 : 0)};
  pointer-events: ${(props) => (props.expanded ? 'auto' : 'none')};
  transition: max-height 0.4s ease, opacity 0.4s ease, padding 0.4s ease-in-out;
`;

const Divider = styled.hr`
  border: none;
  border-top: 1px solid #ddd;
`;

const SectionTitle = styled(Header)`
  &&& {
    font-size: 1rem;
    font-weight: bold;
    margin-bottom: 0.25rem;
  }
`;

const SectionLabel = styled.p`
  font-weight: bold;
  margin-top: 1rem;
  margin-bottom: 0.25rem;
`;

const SubText = styled.p`
  color: #555;
  font-size: 0.9rem;
  margin-bottom: 0.5rem;
`;

const Row = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 0.25rem auto;
  width: 80%;
  max-width: 350px;
  font-weight: 600;
  font-size: 1rem;

  span:first-child {
    color: black;
  }
`;

const Value = styled.span`
  color: ${colors.blue};
`;

const TotalRow = styled(Row)`
  margin-top: 0.75rem;
  border-top: 1px solid #ddd;
  padding-top: 0.75rem;
  font-weight: bold;
  font-size: 1.1rem;
`;

const TotalValue = styled(Value)`
  font-size: 1.1rem;
  font-weight: bold;
`;
